module.exports = __webpack_public_path__ + "img/banner2.832a7013.jpg";